<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk com_pop">
        <div class="pop_tit _flex">
            <p>{{ state.boardItem.title }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="sch_condition_wrap">
            <div class="left _column _flex">
                <div class="date_wrap">
                    <div class="end_point">
                        <span>신청자</span>
                        <span>{{ props.answerInfo.name }}</span>
                    </div>
                    <div class="end_point">
                        <span>
                            <img src="img/time_icon.png" alt="" />
                            신청일자
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(props.answerInfo.createDate), ".") }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="custom_scroll">
            <ul class="areaAnswer">
                <li>
                    <p>휴대폰</p>
                    <div>{{ props.answerInfo.phoneNum }}</div>
                </li>
                <li>
                    <p>이메일</p>
                    <div>{{ props.answerInfo.email }}</div>
                </li>
                <li class="checkbox_wrap">
                    <p>나이</p>
                    <div>
                        <label for="generation1">
                            <input
                                type="radio"
                                id="generation1"
                                name="generation"
                                v-model="props.answerInfo.age"
                                :value="1"
                                :checked="props.answerInfo.age === 1"
                                disabled
                            />
                            <em></em>
                            <span class="form_li_tit">10대</span>
                        </label>
                        <label for="generation2">
                            <input
                                type="radio"
                                id="generation2"
                                name="generation"
                                v-model="props.answerInfo.age"
                                :value="2"
                                :checked="props.answerInfo.age === 2"
                                disabled
                            />
                            <em></em>
                            <span class="form_li_tit">20대</span>
                        </label>
                        <label for="generation3">
                            <input
                                type="radio"
                                id="generation3"
                                name="generation"
                                v-model="props.answerInfo.age"
                                :value="3"
                                :checked="props.answerInfo.age === 3"
                                disabled
                            />
                            <em></em>
                            <span class="form_li_tit">30대</span>
                        </label>
                        <label for="generation4">
                            <input
                                type="radio"
                                id="generation4"
                                name="generation"
                                v-model="props.answerInfo.age"
                                :value="4"
                                :checked="props.answerInfo.age === 4"
                                disabled
                            />
                            <em></em>
                            <span class="form_li_tit">40대</span>
                        </label>
                        <label for="generation5">
                            <input
                                type="radio"
                                id="generation5"
                                name="generation"
                                v-model="props.answerInfo.age"
                                :value="5"
                                :checked="props.answerInfo.age === 5"
                                disabled
                            />
                            <em></em>
                            <span class="form_li_tit">50대</span>
                        </label>
                        <label for="generation6">
                            <input
                                type="radio"
                                id="generation6"
                                name="generation"
                                v-model="props.answerInfo.age"
                                :value="6"
                                :checked="props.answerInfo.age === 6"
                                disabled
                            />
                            <em></em>
                            <span class="form_li_tit">60대</span>
                        </label>
                        <label for="generation7">
                            <input
                                type="radio"
                                id="generation7"
                                name="generation"
                                v-model="props.answerInfo.age"
                                :value="7"
                                :checked="props.answerInfo.age === 7"
                                disabled
                            />
                            <em></em>
                            <span class="form_li_tit">70대 이상</span>
                        </label>
                    </div>
                </li>
                <li class="checkbox_wrap">
                    <p>개인정보 동의</p>
                    <div>
                        <label for="chk1">
                            <input id="chk1" type="checkbox" disabled :checked="props.answerInfo.isAgree == 1" ref="isAgree" />
                            <em></em>
                            <span>개인정보 동의</span>
                        </label>
                    </div>
                </li>
                <li>
                    <p>캠페인 참여 후기/더 알고 싶은 성매매 산업 내용</p>
                    <div>{{ props.answerInfo.reviewComment }}</div>
                </li>
            </ul>
        </div>

        <div class="_flex _center btn_wrap">
            <button class="submit_btn _130 _main_blue" @click="closeModal">닫기</button>
        </div>
    </div>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService } from "@/BaseComponent";

    export default {
        props: {
            answerInfo: {
                type: Object,
                default: {},
            },
        },
        emits: ["close", "callback"],
        components: {},
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                item: {} as any,
                boardItem: {} as any,
                list: [] as Array<any>,

                type: 0 as number,

                idxForRemove: 0 as number,

                itemForItem: {} as any,
                isShowCaseModal: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            onMounted(() => {
                state.idx = props.answerInfo.boIdx;
                state.item = props.answerInfo;
                boardDetail();
            });

            watch(props, () => {
                state.idx = props.answerInfo.boIdx;
                state.item = props.answerInfo;
                boardDetail();
            });

            onUnmounted(() => {});

            const closeModal = () => emit("close");

            const boardDetail = async () => {
                const res = await apiService.board.detail(2, state.idx);
                if (res.returnCode === 0) {
                    state.boardItem = res.data;
                }
            };

            return {
                state,
                props,
                CommonUtils,

                closeModal,
            };
        },
    };
</script>

<style scoped>
    .applicant_chk {
        max-width: 800px;
    }
    .applicant_chk .date_wrap {
        margin: 0;
    }

    .custom_scroll {
        padding-right: 10px;
        overflow-y: auto;
        max-height: calc(100vh - 400px);
    }
    .sch_condition_wrap label {
        color: #a6a6a6;
    }

    .sch_condition_wrap p {
        font-weight: bold;
    }

    ul.areaAnswer {
        margin-top: 5px;
    }

    ul.areaAnswer > li {
        border-bottom: 1px solid #d9d9d9;
        width: 100%;
        margin-bottom: 15px;
    }

    ul.areaAnwer > li p {
        font-family: Noto Sans KR;
        font-weight: 500;
        font-style: Medium;
        font-size: 16px;

        line-height: 100%;
        letter-spacing: 0%;
        color: #252525;
    }

    ul.areaAnswer > li div {
        border: 1px solid #d9d9d9;
        padding: 10px 4px 10px 10px;
        border-radius: 5px;
        margin: 15px 0;
        color: #6d6d6d;
        font-family: Noto Sans KR;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;

        line-height: 22px;
        letter-spacing: 0%;

        display: flex;
        flex-direction: row;
        gap: 10px;
    }

    ul.areaAnswer > li ul > li {
        margin: 15px 0;
    }

    ul.areaAnswer > li ul > li span {
        color: #6d6d6d;
    }

    ul.areaAnswer > li ul > li input + em {
        cursor: auto;
    }

    ul.areaAnswer > li ul > li input[type="checkbox"]:checked + em {
        background-color: var(--accent_color);
        border: 1px solid var(--accent_color);
    }

    ul.areaAnswer > li ul > li input[type="checkbox"]:checked + em + span {
        color: #001c92;
    }

    li.areaSign div {
        max-width: 250px;
    }

    li.areaSign div img {
        width: 100%;
        height: auto;
    }
</style>
